import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postCreateNewFirestops = async (
  projectId,
  listId,
  firestopItemsToCreate,
  firestopImagesToAdd
) => {
  const apiPath = `firestop-documentation/project/${projectId}/list/${listId}/add-new-firestops`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {
      firestopItemsToCreate,
      firestopImagesToAdd,
    },
  });

  const response = await axios(signedRequest);

  return response.data;
};
